/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { motion as m, AnimatePresence } from "framer-motion";
import {
  LayoutDashboard,
  Users,
  Image as ImageIcon,
  MessageSquare,
  Settings,
  Heart,
  DatabaseZap,
  Ticket,
  FileChartColumn,
  ReceiptText
} from "lucide-react";

// Import Komponen
import SidebarAdmin from "../../components/Admin/Common/AdminSidebar";
import TopbarAdmin from "../../components/Admin/Common/AdminTopbar";
import DashboardUtama from "../../components/Admin/Index";
import UserIndex from "../../components/Admin/User/Index";
import VenueIndex from "../../components/Admin/Venue/Index";
import WorkshopIndex from "../../components/Admin/Workshop/Index";
import VoucherIndex from "../../components/Admin/Voucher/Index";
import SettingsIndex from "../../components/Admin/Settings/Index";
import SpeakerIndex from "../../components/Admin/Speaker/Index";
import WorkshopTransactionIndex from "../../components/Admin/Transaction/Workshop/Index";

// Definisi Menu dengan Sub-Menu (Master Data)
const menuItems = [
  { id: "dashboard", name: "Dashboard", icon: <LayoutDashboard size={20} /> },
  { 
    id: "master-data", 
    name: "Master Data", 
    icon: <DatabaseZap size={20} />, 
    children: [
      { id: "user", name: "Daftar Pengguna", icon: <Users size={18} /> },
      { id: "speaker", name: "Daftar Pembicara", icon: <Ticket size={18} /> },
      { id: "venue", name: "Daftar Venue", icon: <Users size={18} /> },
      { id: "workshop", name: "Daftar Workshop", icon: <ImageIcon size={18} /> },
      { id: "voucher", name: "Daftar Voucher", icon: <Ticket size={18} /> },
    ]
  },
  { 
    id: "transaction-data", 
    name: "Transaction", 
    icon: <ReceiptText size={20} />, 
    children: [
      { id: "transaction-workshop", name: "Transaksi Workshop", icon: <Users size={18} /> }
    ]
  },
  { 
    id: "reporting-data", 
    name: "Reporting", 
    icon: <FileChartColumn size={20} />, 
    children: [
      { id: "reporting-workshop", name: "Reporting Workshop", icon: <Users size={18} /> }
    ]
  },
  { id: "settings", name: "Settings", icon: <Settings size={20} /> },
];

const AdminIndex = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 1024);
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("adminActiveTab") || "dashboard";
  });

  useEffect(() => {
    localStorage.setItem("adminActiveTab", activeTab);
    
    // Update Document Title secara dinamis
    const findMenuName = (items) => {
      for (const item of items) {
        if (item.id === activeTab) return item.name;
        if (item.children) {
          const child = item.children.find(c => c.id === activeTab);
          if (child) return child.name;
        }
      }
      return "Admin";
    };
    document.title = `Admin | ${findMenuName(menuItems)}`;
  }, [activeTab]);

  useEffect(() => {
    const handleResize = () => setIsSidebarOpen(window.innerWidth > 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const renderContent = () => {
    switch (activeTab) {
      case "dashboard": return <DashboardUtama />;
      case "user": return <UserIndex />;
      case "speaker": return <SpeakerIndex />;
       case "venue": return <VenueIndex />;
      case "workshop": return <WorkshopIndex />;
      case "voucher": return <VoucherIndex />;
      case "settings": return <SettingsIndex />;
      default: return <DashboardUtama />;
      case "transaction-workshop": return <WorkshopTransactionIndex />;
    }
  };

  return (
    <div className="flex min-h-screen bg-stone-100 font-sans overflow-x-hidden">
      <SidebarAdmin
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
        menuItems={menuItems}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
      />

      <main
        className="flex-1 transition-all duration-300 min-w-0"
        style={{
          marginLeft: window.innerWidth >= 1024 ? (isSidebarOpen ? "260px" : "80px") : "0px",
        }}
      >
        <TopbarAdmin isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

        <div className="p-4 md:p-8">
          <AnimatePresence mode="wait">
            <m.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              className="bg-white rounded-[2rem] p-5 md:p-8 shadow-sm border border-stone-200 min-h-[calc(100vh-120px)]"
            >
              {renderContent()}
            </m.div>
          </AnimatePresence>
        </div>
      </main>

      <style dangerouslySetInnerHTML={{ __html: `.hide-scrollbar::-webkit-scrollbar { display: none; }` }} />
    </div>
  );
};

export default AdminIndex;